const state = {
  projectStore:
    [
      {
        id: 1,
        title_en: "My Curriculum VITAE",
        title_ua: "Моє Резюме",
        title_es: "Mi Currículum VITAE",
        start_date_en: "March 2022",
        start_date_ua: "Березень 2022",
        start_date_es: "Marzo de 2022",
        end_date_en: "April 2022",
        end_date_ua: "Квітень 2022",
        end_date_es: "Abril de 2022",
        description_en: "✨ This modern and adaptive Landing Page succinctly and visually presents my professional information. 🌟 The site is fully responsive and works seamlessly on devices of any size. 📱",
        description_ua: "✨ Це сучасний і адаптивний Landing Page, який стисло й наочно представляє мою професійну інформацію. 🌟 Сайт повністю адаптивний і підходить для перегляду на пристроях будь-якого розміру. 📱",
        description_es: "✨ Esta moderna y adaptativa Landing Page presenta de forma concisa y visual mi información profesional. 🌟 El sitio es completamente adaptable y funciona perfectamente en dispositivos de cualquier tamaño. 📱",
        type_en: "Landing page",
        type_ua: "Цільова сторінка",
        type_es: "Página de destino",
        techno: "HTML5, CSS3, Grid CSS, FlexBox CSS, JavaScript, Markdown, Git, GitHub, GitHub Pages, Google Search Console, Google Analytics, Open Graph protocol, Favicon, Sitemap, Robots.txt",
        sourcelink: "https://github.com/Zorger27/zorger27.github.io",
        demolink: "https://zorger27.github.io",
        youtubelink: "https://youtu.be/jlpmGDHqhy8"
      },
      {
        id: 2,
        title_en: "Calculator",
        title_ua: "Калькулятор",
        title_es: "Calculadora",
        start_date_en: "April 2022",
        start_date_ua: "Квітень 2022",
        start_date_es: "Abril de 2022",
        end_date_en: "April 2022",
        end_date_ua: "Квітень 2022",
        end_date_es: "Abril de 2022",
        description_en: "✨ A functional and user-friendly application, implemented with vanilla JavaScript and web development standards, allows you to perform basic arithmetic operations. 🛠️ The calculator can be used as a standalone application or integrated into existing financial systems. 💼💡",
        description_ua: "✨ Функціональний та зручний додаток, реалізований на ванільному JavaScript і стандартах веброзробки, дозволяє виконувати основні арифметичні операції. 🛠️ Калькулятор можна використовувати як окремий додаток або інтегрувати в існуючі фінансові системи. 💼💡",
        description_es: "✨ Una aplicación funcional y fácil de usar, implementada con JavaScript puro y estándares de desarrollo web, permite realizar operaciones aritméticas básicas. 🛠️ La calculadora se puede utilizar como una aplicación independiente o integrarse en sistemas financieros existentes. 💼💡",
        type_en: "WEB-application",
        type_ua: "WEB-додаток",
        type_es: "Aplicación Web",
        techno: "HTML5, CSS3, JavaScript, Markdown, Git, GitHub",
        sourcelink: "https://github.com/Zorger27/calculator",
        demolink: "https://zorin.expert/extra/calculator",
        youtubelink: "https://youtu.be/jlpmGDHqhy8"
      },
      {
        id: 3,
        title_en: "Spinning cube",
        title_ua: "Куб, що обертається",
        title_es: "El cubo giratorio",
        start_date_en: "May 2022",
        start_date_ua: "Травень 2022",
        start_date_es: "Mayo de 2022",
        end_date_en: "May 2022",
        end_date_ua: "Травень 2022",
        end_date_es: "Mayo de 2022",
        description_en: "🌀 A cube with semi-transparent colorful faces spins in unpredictable directions, creating a dynamic movement effect right in the browser. 🌐 The code is easy to modify, extend, and adapt to other platforms, opening up possibilities for experiments and new ideas. 💡💻",
        description_ua: "🌀 Куб з напівпрозорими різнокольоровими гранями обертається в непередбачуваних напрямках, створюючи ефект динамічного руху прямо в браузері. 🌐 Код легко модифікується, розширюється та адаптується для інших платформ, відкриваючи можливості для експериментів та нових ідей. 💡💻",
        description_es: "🌀 Un cubo con caras semitransparentes y de colores gira en direcciones impredecibles, creando un efecto de movimiento dinámico directamente en el navegador. 🌐 El código es fácil de modificar, ampliar y adaptar a otras plataformas, abriendo posibilidades para experimentos y nuevas ideas. 💡💻",
        type_en: "WEB-application",
        type_ua: "WEB-додаток",
        type_es: "Aplicación Web",
        techno: "HTML5, CSS3, FlexBox CSS, Markdown, Git, GitHub",
        sourcelink: "https://github.com/Zorger27/Spinning-cube",
        demolink: "https://zorin.expert/extra/graphics/cube",
        youtubelink: "https://youtu.be/xXxQ1K_Syns"
      },
      {
        id: 4,
        title_en: "Contact Form",
        title_ua: "Контактна форма",
        title_es: "Formulario de contacto",
        start_date_en: "May 2022",
        start_date_ua: "Травень 2022",
        start_date_es: "Mayo de 2022",
        end_date_en: "May 2022",
        end_date_ua: "Травень 2022",
        end_date_es: "Mayo de 2022",
        description_en: "📬 A user-friendly web application for collecting user information and sending messages to the administrator. ✍️ The form features smart data validation, ensuring the accuracy of submitted information.",
        description_ua: "📬 Зручний вебдодаток для збору інформації про користувачів та передачі повідомлень адміністратору. ✍️ Форма з інтелектуальною валідацією даних гарантує коректність відправленої інформації.",
        description_es: "📬 Una aplicación web fácil de usar para recopilar información de los usuarios y enviar mensajes al administrador. ✍️ El formulario incluye validación inteligente de datos, garantizando la precisión de la información enviada.",
        type_en: "WEB-application",
        type_ua: "WEB-додаток",
        type_es: "Aplicación Web",
        techno: "HTML5, CSS3, JavaScript, Markdown, Git, GitHub",
        sourcelink: "https://github.com/Zorger27/Contact-Form",
        demolink: "",
        youtubelink: "https://youtu.be/jlpmGDHqhy8"
      },
      {
        id: 5,
        title_en: "To-Do list",
        title_ua: "Список справ",
        title_es: "Lista de tareas",
        start_date_en: "May 2022",
        start_date_ua: "Травень 2022",
        start_date_es: "Mayo de 2022",
        end_date_en: "May 2022",
        end_date_ua: "Травень 2022",
        end_date_es: "Mayo de 2022",
        description_en: "📝 A web application for convenient task management, implemented using modern web technologies. ✔️ Allows you to add, edit, delete tasks, mark them as completed (with a visual strikethrough effect), and clear the list entirely.",
        description_ua: "📝 Вебдодаток для зручного управління завданнями, реалізований із використанням сучасних вебтехнологій. ✔️ Дозволяє додавати, редагувати, видаляти завдання, відзначати виконання (з візуальним ефектом перекреслення) та очищати список повністю.",
        description_es: "📝 Una aplicación web para una gestión de tareas conveniente, implementada con tecnologías web modernas. ✔️ Permite agregar, editar, eliminar tareas, marcarlas como completadas (con un efecto visual de tachado) y limpiar la lista por completo.",
        type_en: "WEB-application",
        type_ua: "WEB-додаток",
        type_es: "Aplicación Web",
        techno: "HTML5, CSS3, FlexBox CSS, JavaScript, Markdown, Git, GitHub",
        sourcelink: "https://github.com/Zorger27/To-Do-list",
        demolink: "https://zorin.expert/extra/todo",
        youtubelink: "https://youtu.be/xXxQ1K_Syns"
      },
      {
        id: 6,
        title_en: "Hamburger Menu",
        title_ua: "Гамбургер меню",
        title_es: "Menú Hamburguesa",
        start_date_en: "May 2022",
        start_date_ua: "Травень 2022",
        start_date_es: "Mayo de 2022",
        end_date_en: "May 2022",
        end_date_ua: "Травень 2022",
        end_date_es: "Mayo de 2022",
        description_en: "🍔 An elegant web application with an animated menu! ✨ When you click on the \"hamburger\", the menu opens with a smooth transition, creating a stylish visual effect and enhancing the user experience.",
        description_ua: "🍔 Елегантний вебдодаток із анімованим меню! ✨ При натисканні на \"гамбургер\", меню відкривається з плавним переходом, створюючи стильний візуальний ефект і покращуючи користувацький досвід.",
        description_es: "🍔 Una aplicación web elegante con un menú animado. ✨ Al hacer clic en el \"hamburguesa\", el menú se abre con una transición suave, creando un efecto visual elegante y mejorando la experiencia del usuario.",
        type_en: "WEB-application",
        type_ua: "WEB-додаток",
        type_es: "Aplicación Web",
        techno: "HTML5, CSS3, JavaScript, Markdown, Git, GitHub",
        sourcelink: "https://github.com/Zorger27/Hamburger-menu",
        demolink: "",
        youtubelink: "https://youtu.be/u_PFNLi0Gb4"
      },
      {
        id: 7,
        title_en: "Scroll Snap features",
        title_ua: "Особливості Scroll Snap",
        title_es: "Características de Scroll Snap",
        start_date_en: "May 2022",
        start_date_ua: "Травень 2022",
        start_date_es: "Mayo de 2022",
        end_date_en: "May 2022",
        end_date_ua: "Травень 2022",
        end_date_es: "Mayo de 2022",
        description_en: "🌟 Implemented with pure CSS3, horizontal scrolling provides smooth animations and high performance without using JavaScript. ✨ Easily customizable and adaptable to any design, making it the perfect choice for creating modern web applications and websites. 💡",
        description_ua: "🌟 Реалізований на чистому CSS3, горизонтальний скролінг забезпечує плавні анімації та високу продуктивність без використання JavaScript. ✨ Легко кастомізується та адаптується під будь-який дизайн, що робить його ідеальним вибором для створення сучасних веб-додатків та сайтів. 💡",
        description_es: "🌟 Implementado con CSS3 puro, el desplazamiento horizontal proporciona animaciones suaves y un alto rendimiento sin usar JavaScript. ✨ Fácilmente personalizable y adaptable a cualquier diseño, lo que lo convierte en la elección perfecta para crear aplicaciones web y sitios web modernos. 💡",
        type_en: "WEB-application",
        type_ua: "WEB-додаток",
        type_es: "Aplicación Web",
        techno: "HTML5, CSS3, FlexBox CSS, Markdown, Git, GitHub",
        sourcelink: "https://github.com/Zorger27/Scroll-Snap",
        demolink: "",
        youtubelink: "https://youtu.be/u_PFNLi0Gb4"
      },
      {
        id: 8,
        title_en: "Memory game",
        title_ua: "Гра \"Пам'ять\"",
        title_es: "Juego de Memoria",
        start_date_en: "May 2022",
        start_date_ua: "Травень 2022",
        start_date_es: "Mayo de 2022",
        end_date_en: "May 2022",
        end_date_ua: "Травень 2022",
        end_date_es: "Mayo de 2022",
        description_en: "🔥 An exciting web application that tests your attention and memory. 🎮 The user flips cards to find pairs with matching images. 💡 An interactive interface and cross-platform adaptability make this project perfect for enhancing cognitive skills and entertainment! 🚀",
        description_ua: "🔥 Захопливий веб-додаток, що перевіряє вашу уважність і пам’ять. 🎮 Користувач відкриває карти, щоб знайти пари з однаковими зображеннями. 💡 Інтерактивний інтерфейс і кросплатформна адаптація роблять цей проєкт ідеальним для покращення когнітивних навичок і розваг! 🚀",
        description_es: "🔥 Una emocionante aplicación web que pone a prueba tu atención y memoria. 🎮 El usuario voltea cartas para encontrar pares con imágenes iguales. 💡 Una interfaz interactiva y adaptabilidad multiplataforma hacen de este proyecto una herramienta ideal para mejorar habilidades cognitivas y divertirse al máximo. 🚀",
        type_en: "WEB-application",
        type_ua: "WEB-додаток",
        type_es: "Aplicación Web",
        techno: "HTML5, CSS3, FlexBox CSS, JavaScript, Markdown, Git, GitHub",
        sourcelink: "https://github.com/Zorger27/Memory-game",
        demolink: "https://zorin.expert/extra/games/memory",
        youtubelink: "https://youtu.be/u_PFNLi0Gb4"
      },
      {
        id: 9,
        title_en: "Typical JavaScript interview tasks",
        title_ua: "Типові завдання на співбесіді з JavaScript",
        title_es: "Tareas típicas de entrevistas en JavaScript",
        start_date_en: "June 2022",
        start_date_ua: "Червень 2022",
        start_date_es: "Junio de 2022",
        end_date_en: "June 2022",
        end_date_ua: "Червень 2022",
        end_date_es: "Junio de 2022",
        description_en: "🌟 An interactive web application that allows users to explore and test solutions to popular JavaScript interview questions. 🧩 Users can see and verify how tasks like Palindrome, FizzBuzz, Anagram, Find Vowels, and Fibonacci are solved through intuitive forms with instant feedback.",
        description_ua: "🌟 Інтерактивний веб-додаток, що дозволяє вивчати та тестувати рішення популярних задач зі співбесід по JavaScript. 🧩 Користувач може побачити та перевірити, як вирішуються задачі Palindrome, FizzBuzz, Anagram, Find Vowels і Fibonacci, через зручні форми з миттєвим зворотним зв’язком.",
        description_es: "🌟 Una aplicación web interactiva que permite explorar y probar soluciones a problemas populares de entrevistas en JavaScript. 🧩 Los usuarios pueden ver y comprobar cómo se resuelven desafíos como Palindrome, FizzBuzz, Anagram, Find Vowels y Fibonacci a través de formularios intuitivos con retroalimentación instantánea.",
        type_en: "WEB-application",
        type_ua: "WEB-додаток",
        type_es: "Aplicación Web",
        techno: "HTML5, CSS3, FlexBox CSS, JavaScript, Markdown, Git, GitHub",
        sourcelink: "https://github.com/Zorger27/Typical-JS-tasks",
        demolink: "https://zorin.expert/extra/tasks",
        youtubelink: "https://youtu.be/xXxQ1K_Syns"
      },
      {
        id: 10,
        title_en: "Website template for a blogger",
        title_ua: "Шаблон сайту для блогера",
        title_es: "Plantilla de sitio web para un blogger",
        start_date_en: "June 2022",
        start_date_ua: "Червень 2022",
        start_date_es: "Junio de 2022",
        end_date_en: "July 2022",
        end_date_ua: "Липень 2022",
        end_date_es: "Julio de 2022",
        description_en: "🌐 A convenient and flexible web application that easily adapts to the style and needs of any blogger. 🖋️ Its simplicity of modification, stylish interface, and readiness for use after customization make this project a perfect tool.",
        description_ua: "🌐 Зручний і гнучкий веб-додаток, який легко адаптується під стиль і завдання будь-якого блогера. 🖋️ Простота модифікації, стильний інтерфейс і готовність до використання після налаштування роблять цей проект ідеальним інструментом.",
        description_es: "🌐 Una aplicación web cómoda y flexible que se adapta fácilmente al estilo y las necesidades de cualquier bloguero. 🖋️ Su facilidad de modificación, interfaz elegante y preparación para su uso tras la personalización hacen de este proyecto una herramienta perfecta.",
        type_en: "Single page application",
        type_ua: "Односторінковий додаток",
        type_es: "Aplicación de una sola página",
        techno: "Vue.js, VueX, Vue I18n, Webpack, Node.js, Express.js, Axios, JSON Web Tokens, HTML5, SCSS, FlexBox CSS, TypeScript, JavaScript, Element Plus, Cypress (E2E), Jest (Unit), Markdown, Git, GitHub",
        sourcelink: "https://github.com/Zorger27/Blog-site",
        demolink: "",
        youtubelink: "https://youtu.be/xXxQ1K_Syns"
      },
      {
        id: 11,
        title_en: "Dropdown Menu",
        title_ua: "Випадаюче меню",
        title_es: "Menú desplegable",
        start_date_en: "August 2022",
        start_date_ua: "Серпень 2022",
        start_date_es: "Agosto de 2022",
        end_date_en: "August 2022",
        end_date_ua: "Серпень 2022",
        end_date_es: "Agosto de 2022",
        description_en: "🔽 An elegant and efficient web application, built using only CSS3. ✨ Simple architecture ensures cross-platform compatibility and easy integration into any project. 💡 Works perfectly \"out of the box\" and easily adapts to any needs! 🚀",
        description_ua: "🔽 Елегантний та ефективний веб-додаток, побудований виключно за допомогою CSS3. ✨ Проста архітектура забезпечує кросплатформеність та легкість інтеграції в будь-які проекти. 💡 Ідеально працює \"з коробки\" і легко адаптується під будь-які потреби! 🚀",
        description_es: "🔽 Aplicación web elegante y eficiente, construida exclusivamente con CSS3. ✨ Arquitectura simple que garantiza compatibilidad multiplataforma e integración fácil en cualquier proyecto. 💡 Funciona perfectamente \"listo para usar\" y se adapta fácilmente a cualquier necesidad. 🚀",
        type_en: "WEB-application",
        type_ua: "WEB-додаток",
        type_es: "Aplicación Web",
        techno: "HTML5, CSS3, Markdown, Git, GitHub",
        sourcelink: "https://github.com/Zorger27/Dropdown-Menu",
        demolink: "",
        youtubelink: "https://youtu.be/u_PFNLi0Gb4"
      },
      {
        id: 12,
        title_en: "Sidebar Menu",
        title_ua: "Меню на бічній панелі",
        title_es: "Menú de la barra lateral",
        start_date_en: "August 2022",
        start_date_ua: "Серпень 2022",
        start_date_es: "Agosto de 2022",
        end_date_en: "August 2022",
        end_date_ua: "Серпень 2022",
        end_date_es: "Agosto de 2022",
        description_en: "☕️ A stylish website template with a convenient sidebar menu, perfect for coffee brands. 📱 With a single click, the menu transforms from a compact set of icons created with Boxicons CSS into a full-fledged list with text labels for each section.",
        description_ua: "☕️ Стильний шаблон сайту з зручним боковим меню, ідеально підходить для кавових брендів. 📱 Одним кліком меню перетворюється з компактного набору іконок, створених за допомогою Boxicons CSS, у повноцінний список із текстовими назвами розділів.",
        description_es: "☕️ Una elegante plantilla de sitio web con un práctico menú lateral, ideal para marcas de café. 📱 Con un solo clic, el menú se transforma de un conjunto compacto de íconos creados con Boxicons CSS a una lista completa con etiquetas de texto para cada sección.",
        type_en: "WEB-application",
        type_ua: "WEB-додаток",
        type_es: "Aplicación Web",
        techno: "HTML5, CSS3, Boxicons CSS, JavaScript, Markdown, Git, GitHub",
        sourcelink: "https://github.com/Zorger27/Sidebar-Menu",
        demolink: "",
        youtubelink: "https://youtu.be/7rmrqh2TeI8"
      },
      {
        id: 13,
        title_en: "My favorite buttons",
        title_ua: "Мої улюблені кнопки",
        title_es: "Mis botones favoritos",
        start_date_en: "August 2022",
        start_date_ua: "Серпень 2022",
        start_date_es: "Agosto de 2022",
        end_date_en: "August 2022",
        end_date_ua: "Серпень 2022",
        end_date_es: "Agosto de 2022",
        description_en: "✨ Elegant buttons with unique CSS3 effects, which change their behavior when hovered. 💻 The code is modular, making it easy to modify and adapt to any platform. 🔥 This project is a great example of a dynamic and creative approach to interface design. 🎨",
        description_ua: "✨ Елегантні кнопки з унікальними CSS3-ефектами, які змінюють свою поведінку при наведенні. 💻 Код поділений на модулі, що полегшує модифікацію та адаптацію під будь-які платформи. 🔥 Цей проект — чудовий приклад динамічного та креативного підходу до створення інтерфейсів. 🎨",
        description_es: "✨ Botones elegantes con efectos CSS3 únicos, que cambian su comportamiento al pasar el cursor. 💻 El código está dividido en módulos, lo que facilita la modificación y adaptación a cualquier plataforma. 🔥 Este proyecto es un excelente ejemplo de un enfoque dinámico y creativo en el diseño de interfaces. 🎨",
        type_en: "WEB-application",
        type_ua: "WEB-додаток",
        type_es: "Aplicación Web",
        techno: "HTML5, CSS3, FlexBox CSS, Markdown, Git, GitHub",
        sourcelink: "https://github.com/Zorger27/Fav-buttons",
        demolink: "",
        youtubelink: "https://youtu.be/7rmrqh2TeI8"
      },
      {
        id: 14,
        title_en: "My Portfolio",
        title_ua: "Моє Портфоліо",
        title_es: "Mi Portafolio",
        start_date_en: "February 2023",
        start_date_ua: "Лютий 2023",
        start_date_es: "Febrero de 2023",
        end_date_en: "June 2023",
        end_date_ua: "Червень 2023",
        end_date_es: "Junio de 2023",
        description_en: "👨‍💻 This is a modern single-page application (SPA) that presents my professional information in a detailed way. ✨ The site covers everything that matters: Detailed resume (projects with descriptions, diplomas, certificates, work experience, skills, and education) and Extra section (examples of completed works: To-do list, Weather, Cryptocurrencies, 3D graphics and much more). 🌟",
        description_ua: "👨‍💻 Це сучасний односторінковий додаток (SPA), який детально представляє мою професійну інформацію. ✨ Сайт охоплює все, що важливо: Детальне резюме (проекти з описами, дипломи, сертифікати, досвід роботи, навички та освіта) і Екстра-розділ (приклади готових робіт: список справ, погода, криптовалюти, 3D графіка та багато іншого). 🌟",
        description_es: "👨‍💻 Esta es una aplicación moderna de una sola página (SPA) que presenta mi información profesional de manera detallada. ✨ El sitio cubre todo lo que es importante: Currículum detallado (proyectos con descripciones, diplomas, certificados, experiencia laboral, habilidades y educación) y Sección extra (ejemplos de trabajos realizados: Lista de tareas, El Tiempo, Criptomonedas, Gráficos 3D y mucho más). 🌟",
        type_en: "Single page application",
        type_ua: "Односторінковий додаток",
        type_es: "Aplicación de una sola página",
        techno: "Three.js, Vue.js, VueX, Vue I18n, Webpack, HTML5, SCSS, Grid CSS, FlexBox CSS, TypeScript, JavaScript, Axios, Markdown, Git, GitHub, Google Search Console, Google Analytics, Open Graph protocol, Favicon, Sitemap, Robots.txt",
        sourcelink: "https://github.com/Zorger27/CV-Vue",
        demolink: "https://Zorin.Expert",
        youtubelink: "https://youtu.be/fwBFfrhPJyM"
      },
      {
        id: 15,
        title_en: "Vue.js template with TypeScript",
        title_ua: "Шаблон Vue.js + TypeScript",
        title_es: "Plantilla Vue.js con TypeScript",
        start_date_en: "December 2023",
        start_date_ua: "Грудень 2023",
        start_date_es: "Diciembre de 2023",
        end_date_en: "January 2024",
        end_date_ua: "Січень 2024",
        end_date_es: "Enero de 2024",
        description_en: "🌐 A powerful starter template for developing Single Page Applications (SPA), perfectly suited for modern web projects. 🚀 Easy customization and scalability make this template the perfect foundation for building complex and feature-rich applications.",
        description_ua: "🌐 Потужний стартовий шаблон для розробки односторінкових застосунків (SPA), що ідеально підходить для сучасних веб-проектів. 🚀 Легкість модифікації та масштабування роблять цей шаблон ідеальною основою для створення складних і багатофункціональних застосунків.",
        description_es: "🌐 Una poderosa plantilla inicial para desarrollar aplicaciones de una sola página (SPA), perfectamente adecuada para proyectos web modernos. 🚀 La facilidad de personalización y escalabilidad hacen de esta plantilla la base perfecta para crear aplicaciones complejas y con múltiples funciones.",
        type_en: "Single page application",
        type_ua: "Односторінковий додаток",
        type_es: "Aplicación de una sola página",
        techno: "Vue.js, VueX, Vue I18n, Webpack, HTML5, SCSS, FlexBox CSS, TypeScript, JavaScript, Markdown, Git, GitHub, Google Search Console, Google Analytics, Open Graph protocol, Favicon, Sitemap, Robots.txt",
        sourcelink: "https://github.com/Zorger27/Vue-TS-Template",
        demolink: "https://vue-template-ts.vercel.app",
        youtubelink: "https://youtu.be/jlpmGDHqhy8"
      },
      {
        id: 16,
        title_en: "Rotating 3D cube",
        title_ua: "3D куб, що обертається",
        title_es: "Cubo 3D giratorio",
        start_date_en: "December 2023",
        start_date_ua: "Грудень 2023",
        start_date_es: "Diciembre de 2023",
        end_date_en: "January 2024",
        end_date_ua: "Січень 2024",
        end_date_es: "Enero de 2024",
        description_en: "🎲 The colorful rotating cube allows users to take full control of the model: scaling, adjusting the viewing angle, stopping and starting rotation, and spinning it in any direction for detailed exploration. 🚀",
        description_ua: "🎲 Різнокольоровий куб, що обертається, дозволяє користувачу повністю керувати моделлю: змінювати масштаб, змінювати кут огляду, зупиняти та запускати обертання, а також обертати в будь-якому напрямку для детального перегляду. 🚀",
        description_es: "🎲 El colorido cubo giratorio permite a los usuarios tener un control total del modelo: escalar, ajustar el ángulo de visión, detener y reanudar la rotación, además de girarlo en cualquier dirección para una exploración detallada. 🚀",
        type_en: "Single page application",
        type_ua: "Односторінковий додаток",
        type_es: "Aplicación de una sola página",
        techno: "Three.js, Orbit controls, Vue.js, VueX, Vue I18n, Webpack, HTML5, SCSS, FlexBox CSS, TypeScript, JavaScript, Markdown, Git, GitHub, Open Graph protocol, Favicon, Sitemap, Robots.txt",
        sourcelink: "https://github.com/Zorger27/Vue-Threejs-1",
        demolink: "https://vue-threejs-1.vercel.app",
        youtubelink: "https://youtu.be/7rmrqh2TeI8"
      },
      {
        id: 17,
        title_en: "Vue.js template with JavaScript",
        title_ua: "Шаблон Vue.js + JavaScript",
        title_es: "Plantilla Vue.js con JavaScript",
        start_date_en: "December 2023",
        start_date_ua: "Грудень 2023",
        start_date_es: "Diciembre de 2023",
        end_date_en: "January 2024",
        end_date_ua: "Січень 2024",
        end_date_es: "Enero de 2024",
        description_en: "🌐 A convenient and flexible starter template for building modern single-page applications (SPA). 🚀 With its intuitive structure and code flexibility, this template is perfect for quickly starting new projects or developing complex web applications! 🌟",
        description_ua: "🌐 Зручний та гнучкий стартовий шаблон для створення сучасних односторінкових додатків (SPA). 🚀 Завдяки інтуїтивно зрозумілій структурі та гнучкості коду, цей шаблон ідеально підходить як для швидкого старту нових проектів, так і для розробки складних веб-додатків! 🌟",
        description_es: "🌐 Plantilla de inicio conveniente y flexible para crear aplicaciones web de una sola página (SPA) modernas. 🚀 Con su estructura intuitiva y la flexibilidad del código, ¡esta plantilla es perfecta tanto para iniciar nuevos proyectos rápidamente como para desarrollar aplicaciones web complejas! 🌟",
        type_en: "Single page application",
        type_ua: "Односторінковий додаток",
        type_es: "Aplicación de una sola página",
        techno: "Vue.js, VueX, Vue I18n, Webpack, HTML5, SCSS, FlexBox CSS, JavaScript, Markdown, Git, GitHub, Google Search Console, Google Analytics, Open Graph protocol, Favicon, Sitemap, Robots.txt",
        sourcelink: "https://github.com/Zorger27/Vue-JS-Template",
        demolink: "https://vue-template-js.vercel.app",
        youtubelink: "https://youtu.be/u_PFNLi0Gb4"
      },
      {
        id: 18,
        title_en: "Vue.js & Three.js template",
        title_ua: "Шаблон Vue.js + Three.js",
        title_es: "Plantilla Vue.js y Three.js",
        start_date_en: "January 2024",
        start_date_ua: "Січень 2024",
        start_date_es: "Enero de 2024",
        end_date_en: "January 2024",
        end_date_ua: "Січень 2024",
        end_date_es: "Enero de 2024",
        description_en: "🌐 A convenient and powerful starter template for creating modern Single Page Applications (SPA) with 3D graphics integration. 🚀 Thanks to its flexibility and scalability, this solution is perfect for any web project that supports 3D graphics! 💻🌟",
        description_ua: "🌐 Зручний і потужний стартовий шаблон для створення сучасних односторінкових застосунків (SPA) з інтеграцією 3D-графіки. 🚀 Завдяки гнучкості та масштабованості це рішення підходить для будь-якого веб-проекту з підтримкою 3D-графіки! 💻🌟",
        description_es: "🌐 Una plantilla inicial conveniente y poderosa para crear aplicaciones de una sola página (SPA) modernas con integración de gráficos 3D. 🚀 Gracias a su flexibilidad y escalabilidad, esta solución es perfecta para cualquier proyecto web con soporte para gráficos 3D. 💻🌟",
        type_en: "Single page application",
        type_ua: "Односторінковий додаток",
        type_es: "Aplicación de una sola página",
        techno: "Three.js, Orbit controls, Vue.js, VueX, Vue I18n, Webpack, HTML5, SCSS, FlexBox CSS, JavaScript, Markdown, Git, GitHub, Google Search Console, Google Analytics, Open Graph protocol, Favicon, Sitemap, Robots.txt",
        sourcelink: "https://github.com/Zorger27/Vue-Threejs-Template",
        demolink: "https://vue-threejs-template.vercel.app",
        youtubelink: "https://youtu.be/7rmrqh2TeI8"
      },
      {
        id: 19,
        title_en: "CuboVerse",
        title_ua: "CuboVerse",
        title_es: "CuboVerse",
        start_date_en: "January 2024",
        start_date_ua: "Січень 2024",
        start_date_es: "Enero de 2024",
        end_date_en: "January 2024",
        end_date_ua: "Січень 2024",
        end_date_es: "Enero de 2024",
        description_en: "🪐 CuboVerse (a combination of the Spanish word \"cubo\" (meaning \"cube\") and the English word \"universe\" (meaning \"universe\"), i.e., \"the universe of cubes\") is an interactive 3D platform that allows users to observe and control various cube models in a virtual space. 🌟",
        description_ua: "🪐 CuboVerse (поєднання слів \"cubo\" (іспанською — куб) і \"universe\" (англійською — всесвіт), тобто \"всесвіт кубів\") — це інтерактивна 3D-платформа, що дозволяє користувачам спостерігати та керувати різноманітними моделями кубів у віртуальному просторі. 🌟",
        description_es: "🪐 CuboVerse (una combinación de la palabra \"cubo\" (en español, \"cubo\") y \"universe\" (en inglés, \"universo\"), es decir, \"el universo de cubos\") es una plataforma interactiva en 3D que permite a los usuarios observar y controlar diversos modelos de cubos en un espacio virtual. 🌟",
        type_en: "Single page application",
        type_ua: "Односторінковий додаток",
        type_es: "Aplicación de una sola página",
        techno: "Three.js, Orbit controls, Vue.js, VueX, Vue I18n, Webpack, HTML5, SCSS, FlexBox CSS, JavaScript, Markdown, Git, GitHub, Google Search Console, Google Analytics, Open Graph protocol, Favicon, Sitemap, Robots.txt",
        sourcelink: "https://github.com/Zorger27/Vue-Threejs-2",
        demolink: "https://vue-threejs-2.vercel.app",
        youtubelink: "https://youtu.be/LJH-S5KKerw"
      },
      {
        id: 20,
        title_en: "Exchange rates",
        title_ua: "Курси валют",
        title_es: "Tipos de cambio",
        start_date_en: "March 2024",
        start_date_ua: "Березень 2024",
        start_date_es: "Marzo de 2024",
        end_date_en: "March 2024",
        end_date_ua: "Березень 2024",
        end_date_es: "Marzo de 2024",
        description_en: "💹 This modern web application is designed to provide a convenient and visual display of current foreign exchange rates. 🚀 The app retrieves real-time data from the National Bank of Ukraine API, displaying exchange rates relative to the Ukrainian hryvnia (UAH) in innovative and interactive formats. 📈",
        description_ua: "💹 Це сучасний вебдодаток, створений для зручного та наочного відображення актуальних курсів іноземних валют. 🚀 Додаток отримує дані в режимі реального часу через API Національного банку України, відображаючи курси валют відносно української гривні (UAH) в інноваційних та інтерактивних форматах. 📈",
        description_es: "💹 Esta moderna aplicación web está diseñada para proporcionar una visualización cómoda y clara de los tipos de cambio de divisas actuales. 🚀 La aplicación obtiene datos en tiempo real del API del Banco Nacional de Ucrania, mostrando los tipos de cambio en relación con la grivna ucraniana (UAH) en formatos innovadores e interactivos. 📈",
        type_en: "Single page application",
        type_ua: "Односторінковий додаток",
        type_es: "Aplicación de una sola página",
        techno: "Three.js, Vue.js, VueX, Vue I18n, Webpack, HTML5, SCSS, FlexBox CSS, TypeScript, JavaScript, Axios, Markdown, Git, GitHub, Google Search Console, Google Analytics, Open Graph protocol, Favicon, Sitemap, Robots.txt",
        sourcelink: "https://github.com/Zorger27/Currencies",
        demolink: "https://currencies-zeta.vercel.app",
        youtubelink: "https://youtu.be/5ofx4IjOSuw"
      },
      {
        id: 21,
        title_en: "Cryptocurrencies",
        title_ua: "Криптовалюти",
        title_es: "Criptomonedas",
        start_date_en: "March 2024",
        start_date_ua: "Березень 2024",
        start_date_es: "Marzo de 2024",
        end_date_en: "March 2024",
        end_date_ua: "Березень 2024",
        end_date_es: "Marzo de 2024",
        description_en: "💎 This web application transforms cryptocurrency rate monitoring into an engaging experience. 📈 Using the CoinGecko API, it displays up-to-date cryptocurrency rates in USD, offering users flexibility and interactivity. Technologies and data come together, enabling you to easily track the world of cryptocurrencies. 🌟",
        description_ua: "💎 Цей вебдодаток перетворює моніторинг курсів криптовалют на захопливий досвід. 📈 Завдяки API CoinGecko він відображає актуальні курси криптовалют у доларах США (USD), пропонуючи користувачам гнучкість та інтерактивність. Технології та дані поєднуються в єдине ціле, щоб ви могли легко відстежувати світ криптовалют. 🌟",
        description_es: "💎 Esta aplicación web transforma el monitoreo de tasas de criptomonedas en una experiencia fascinante. 📈 Con la API de CoinGecko, muestra las tasas actualizadas de criptomonedas en dólares estadounidenses (USD), ofreciendo a los usuarios flexibilidad e interactividad. Las tecnologías y los datos se unen para que puedas seguir fácilmente el mundo de las criptomonedas. 🌟",
        type_en: "Single page application",
        type_ua: "Односторінковий додаток",
        type_es: "Aplicación de una sola página",
        techno: "Three.js, Vue.js, VueX, Vue I18n, Webpack, HTML5, SCSS, FlexBox CSS, TypeScript, JavaScript, Axios, Markdown, Git, GitHub, Google Search Console, Google Analytics, Open Graph protocol, Favicon, Sitemap, Robots.txt",
        sourcelink: "https://github.com/Zorger27/Cryptocurrencies",
        demolink: "https://cryptocurrencies-gold.vercel.app",
        youtubelink: "https://youtu.be/-kGUesQdUs8"
      },
      {
        id: 22,
        title_en: "Weather forecast",
        title_ua: "Прогноз погоди",
        title_es: "El Tiempo",
        start_date_en: "March 2024",
        start_date_ua: "Березень 2024",
        start_date_es: "Marzo de 2024",
        end_date_en: "April 2024",
        end_date_ua: "Квітень 2024",
        end_date_es: "Abril de 2024",
        description_en: "☀️ Custom-built weather forecasting application that delivers real-time data from OpenWeather for any city worldwide. 🌈 Whether you're a tech enthusiast or just curious about the weather, this app has something for everyone! ⛄️",
        description_ua: "☀️ Унікальний веб-додаток для прогнозу погоди, який використовує актуальні дані в реальному часі від OpenWeather для будь-якого міста світу. 🌈 Незалежно від того, чи ви захоплюєтеся технологіями, чи просто цікавитеся погодою, цей додаток має щось цікаве для кожного! ⛄️",
        description_es: "☀️ Una aplicación web personalizada para pronósticos meteorológicos, que proporciona datos en tiempo real de OpenWeather para cualquier ciudad del mundo. 🌈 Ya sea que seas un entusiasta de la tecnología o simplemente tengas curiosidad por el clima, ¡esta app tiene algo para todos! ⛄️",
        type_en: "Single page application",
        type_ua: "Односторінковий додаток",
        type_es: "Aplicación de una sola página",
        techno: "Three.js, Vue.js, VueX, Vue I18n, Webpack, HTML5, SCSS, FlexBox CSS, TypeScript, JavaScript, Axios, Markdown, Git, GitHub, Google Search Console, Google Analytics, Open Graph protocol, Favicon, Sitemap, Robots.txt",
        sourcelink: "https://github.com/Zorger27/Weather",
        demolink: "https://weather-zorger.vercel.app",
        youtubelink: "https://youtu.be/cg_zJ77DHhI"
      },
      {
        id: 23,
        title_en: "3D Configurators",
        title_ua: "3D-конфігуратори",
        title_es: "Configuradores 3D",
        start_date_en: "September 2024",
        start_date_ua: "Вересень 2024",
        start_date_es: "Septiembre de 2024",
        end_date_en: "September 2024",
        end_date_ua: "Вересень 2024",
        end_date_es: "Septiembre de 2024",
        description_en: "👑 This is an innovative online technology that enables users to interact with 3D product models in real-time. 🚀 It’s a powerful tool for businesses that allows your customers to customize products to their preferences — changing colors, textures, and other parameters and seeing the results instantly. 🏆",
        description_ua: "👑 Це інноваційна онлайн-технологія, яка дозволяє користувачам взаємодіяти з 3D-моделями продуктів у реальному часі. 🚀 Це потужний інструмент для бізнесу, який дає вашим клієнтам змогу налаштовувати продукт відповідно до своїх вподобань — змінювати колір, текстуру та інші параметри й одразу бачити результат. 🏆",
        description_es: "👑 Esto es una tecnología en línea innovadora que permite a los usuarios interactuar con modelos de productos en 3D en tiempo real. 🚀 Es una herramienta poderosa para empresas que permite a los clientes personalizar productos según sus preferencias: cambiar colores, texturas y otros parámetros, y ver los resultados al instante. 🏆",
        type_en: "Single page application",
        type_ua: "Односторінковий додаток",
        type_es: "Aplicación de una sola página",
        techno: "Three.js, Orbit controls, Vue.js, VueX, Vue I18n, Webpack, HTML5, SCSS, FlexBox CSS, JavaScript, Markdown, Git, GitHub, Google Search Console, Google Analytics, Open Graph protocol, Favicon, Sitemap, Robots.txt",
        sourcelink: "https://github.com/Zorger27/3dConfigurator",
        demolink: "https://3d-configurator-max.vercel.app",
        youtubelink: "https://youtu.be/uUofz_KBYuU"
      },
      {
        id: 24,
        title_en: "Couture Metaverse 3D",
        title_ua: "Метавсесвіт від кутюр 3D",
        title_es: "Metaverso 3D de alta costura",
        start_date_en: "February 2025",
        start_date_ua: "Лютий 2025",
        start_date_es: "Febrero de 2025",
        end_date_en: "March 2025",
        end_date_ua: "Березень 2025",
        end_date_es: "Marzo de 2025",
        description_en: "🎨 A unique platform for creating and customizing 3D models! 👗 Choose colors, add textures, apply branding, and create stylish looks! 🕶️👕 Experiment, mix, and customize – your design, your rules! 🚀 Save your creations in JPG, PNG, PDF or MP4 formats and share them with the world! 📸",
        description_ua: "🎨 Унікальна платформа для створення та кастомізації 3D-моделей! 👗 Оберіть кольори, додайте текстури, нанесіть логотипи та створюйте стильні образи! 🕶️👕 Експериментуйте, поєднуйте та налаштовуйте – ваш дизайн, ваші правила! 🚀 Зберігайте свої творіння у форматах JPG, PNG, PDF чи MP4 та діліться ними зі світом! 📸",
        description_es: "🎨 ¡Una plataforma única para crear y personalizar modelos 3D! 👗 ¡Elige colores, añade texturas, aplica marcas y crea looks elegantes! 🕶️👕 ¡Experimenta, combina y personaliza – tu diseño, tus reglas! 🚀 Guarda tus creaciones en formatos JPG, PNG, PDF o MP4 y ¡compártelas con el mundo! 📸",
        type_en: "Single page application",
        type_ua: "Односторінковий додаток",
        type_es: "Aplicación de una sola página",
        techno: "Three.js, Orbit controls, Vue.js, VueX, Vue I18n, Webpack, HTML5, SCSS, FlexBox CSS, JavaScript, Markdown, Git, GitHub, Google Search Console, Google Analytics, Open Graph protocol, Favicon, Sitemap, Robots.txt",
        sourcelink: "https://github.com/Zorger27/Couture-Metaverse",
        demolink: "https://couture-metaverse.vercel.app",
        youtubelink: "https://youtu.be/DbePF2FoOn4"
      },
      {
        id: 25,
        title_en: "React & Vite PWA Template",
        title_ua: "Шаблон PWA на React та Vite",
        title_es: "Plantilla PWA de React y Vite",
        start_date_en: "July 2025",
        start_date_ua: "Липень 2025",
        start_date_es: "Julio de 2025",
        end_date_en: "August 2025",
        end_date_ua: "Серпень 2025",
        end_date_es: "Agosto de 2025",
        description_en: "🌐 A starter template for building modern single-page applications (SPA), powered by a contemporary tech stack. It features offline support (PWA) and fast loading, ensuring excellent performance even on slow networks. 🚀 This template is perfect for quickly launching new projects or developing complex web applications! 🌟",
        description_ua: "🌐 Стартовий шаблон для створення сучасних односторінкових додатків (SPA), побудований на сучасному стеку технологій. Підтримується офлайн-режим (PWA), а швидке завантаження забезпечує відмінну продуктивність навіть на повільних мережах. 🚀 Цей шаблон ідеально підходить як для швидкого старту нових проектів, так і для розробки складних веб-додатків! 🌟",
        description_es: "🌐 Plantilla inicial para crear aplicaciones modernas de una sola página (SPA), desarrollada con un stack tecnológico actual. Incluye soporte sin conexión (PWA) y carga rápida, lo que garantiza un rendimiento excelente incluso en redes lentas. 🚀 Esta plantilla es ideal tanto para el lanzamiento rápido de nuevos proyectos como para el desarrollo de aplicaciones web complejas. 🌟",
        type_en: "Single page application",
        type_ua: "Односторінковий додаток",
        type_es: "Aplicación de una sola página",
        techno: "React, React Router, Redux Toolkit, React i18next, Vite, HTML5, SCSS, FlexBox CSS, Grid CSS, JavaScript, Markdown, Git, GitHub, Google Search Console, Google Analytics, Open Graph protocol, Favicon, Sitemap, Robots.txt",
        sourcelink: "https://github.com/Zorger27/React-JS-Template",
        demolink: "https://react-js-template.vercel.app",
        youtubelink: "https://youtu.be/nZTrEuyZIwg"
      },
      {
        id: 26,
        title_en: "Reactorium",
        title_ua: "Reactorium",
        title_es: "Reactorium",
        start_date_en: "August 2025",
        start_date_ua: "Серпень 2025",
        start_date_es: "Agosto de 2025",
        end_date_en: "September 2025",
        end_date_ua: "Вересень 2025",
        end_date_es: "Septiembre de 2025",
        description_en: "⚛️ Reactorium (a blend of \"React\" (the UI library) and \"laboratorium\" (Latin for \"laboratory, a place for experiments\"), meaning \"React laboratory\") — a secret laboratory of React experiments, where each application holds a surprise crafted from lines of code and a touch of magic! 🚀 Reactorium is where modern technologies meet simple and engaging ideas.",
        description_ua: "⚛️ Reactorium (поєднання слів \"React\" (назва бібліотеки для інтерфейсів) і \"laboratorium\" (латиною — \"лабораторія, місце для дослідів\"), тобто \"лабораторія React\") — секретна лабораторія React-експериментів, де кожен додаток приховує сюрприз, створений із рядків коду та дотику магії! 🚀 Reactorium — це простір, де сучасні технології поєднуються з простими й захопливими ідеями.",
        description_es: "⚛️ Reactorium (combinación de \"React\" (nombre de la biblioteca de interfaces) y \"laboratorium\" (en latín — \"laboratorio, lugar de experimentos\"), es decir, \"laboratorio React\") — un laboratorio secreto de experimentos con React, donde cada aplicación guarda una sorpresa creada a partir de líneas de código y una pizca de magia! 🚀 Reactorium es el lugar donde la tecnología moderna se une con ideas simples y atractivas.",
        type_en: "Single page application",
        type_ua: "Односторінковий додаток",
        type_es: "Aplicación de una sola página",
        techno: "React, React Router, Redux Toolkit, React i18next, Vite, HTML5, SCSS, FlexBox CSS, Grid CSS, JavaScript, Markdown, Git, GitHub, Google Search Console, Google Analytics, Open Graph protocol, Favicon, Sitemap, Robots.txt",
        sourcelink: "https://github.com/Zorger27/Reactorium",
        demolink: "https://reactorium-zorger.vercel.app",
        youtubelink: "https://youtu.be/D6ln_n3vJlc"
      },
      {
        id: 27,
        title_en: "Reactorium 3D",
        title_ua: "Reactorium 3D",
        title_es: "Reactorium 3D",
        start_date_en: "September 2025",
        start_date_ua: "Вересень 2025",
        start_date_es: "Septiembre de 2025",
        end_date_en: "December 2025",
        end_date_ua: "Грудень 2025",
        end_date_es: "Diciembre de 2025",
        description_en: "🔮 Reactorium 3D is a “React laboratory in the space of three dimensions”, where React, Three.js and React Three Fiber merge to create interactive worlds filled with shapes, motion and light. 🧪 Each application here is a small experiment in a three-dimensional environment, ranging from abstract scenes and dynamic objects to interactive tools and games. ✨",
        description_ua: "🔮 Reactorium 3D — це «лабораторія React у просторі трьох вимірів», де React, Three.js і React Three Fiber поєднуються, щоб створювати інтерактивні світи, наповнені формами, рухом і світлом. 🧪 Кожен застосунок тут — маленький експеримент у тривимірному середовищі: від абстрактних сцен і динамічних об’єктів до інтерактивних інструментів та ігор. ✨",
        description_es: "🔮 Reactorium 3D es un «laboratorio de React en el espacio de tres dimensiones», donde React, Three.js y React Three Fiber se unen para crear mundos interactivos llenos de formas, movimiento y luz. 🧪 Cada aplicación aquí es un pequeño experimento en un entorno tridimensional: desde escenas abstractas y objetos dinámicos hasta herramientas e incluso juegos interactivos. ✨",
        type_en: "Single page application",
        type_ua: "Односторінковий додаток",
        type_es: "Aplicación de una sola página",
        techno: "React, Three.js, React Three Fiber, React Router, Redux Toolkit, React i18next, Vite, HTML5, SCSS, FlexBox CSS, Grid CSS, JavaScript, Markdown, Git, GitHub, Google Search Console, Google Analytics, SEO toolkit (full)",
        sourcelink: "https://github.com/Zorger27/Reactorium-3D",
        demolink: "https://reactorium-3d.vercel.app",
        youtubelink: "https://youtu.be/Wt77Q8cDKgM"
      },
      {
        id: 28,
        title_en: "Shaders",
        title_ua: "Shaders",
        title_es: "Shaders",
        start_date_en: "June 2026",
        start_date_ua: "Червень 2026",
        start_date_es: "Junio de 2026",
        end_date_en: "July 2026",
        end_date_ua: "Липень 2026",
        end_date_es: "Julio de 2026",
        description_en: "⚡ Shaders is a research platform for exploring the capabilities of modern GPU graphics, shaders, and parallel computing with WebGPU. 🧠 From Vertex and Fragment Shaders to GPGPU, Raymarching, and TSL Instancing, the project systematically explores the core technologies of the modern graphics pipeline, demonstrating their practical application in high-performance interactive web applications and next-generation commercial graphics systems. 🚀",
        description_ua: "⚡ Shaders — дослідницька платформа для вивчення можливостей сучасної GPU-графіки, шейдерів і паралельних обчислень у WebGPU. 🧠 Від Vertex і Fragment Shader’ів до GPGPU, Raymarching і TSL Instancing — проєкт послідовно досліджує ключові технології сучасного графічного конвеєра, демонструючи їх практичне застосування у високопродуктивних інтерактивних вебдодатках і комерційних графічних системах нового покоління. 🚀",
        description_es: "⚡ Shaders es una plataforma de investigación para explorar las capacidades de los gráficos modernos acelerados por GPU, los shaders y la computación paralela con WebGPU. 🧠 Desde Vertex y Fragment Shaders hasta GPGPU, Raymarching y TSL Instancing, el proyecto explora de forma sistemática las tecnologías fundamentales del pipeline gráfico moderno, demostrando su aplicación práctica en aplicaciones web interactivas de alto rendimiento y en sistemas gráficos comerciales de nueva generación. 🚀",
        type_en: "Single page application",
        type_ua: "Односторінковий додаток",
        type_es: "Aplicación de una sola página",
        techno: "React, Three.js, Three.js Shading Language (TSL), React Three Fiber, React Three Drei, React Router, Redux Toolkit, React i18next, Vite, HTML5, SCSS, JavaScript, Markdown, Git, GitHub, Google Search Console, Google Analytics, SEO toolkit (full)",
        sourcelink: "https://github.com/Zorger27/Shaders",
        demolink: "https://shaders-zorger.vercel.app",
        youtubelink: "https://youtu.be/V_3cWkZJIrA"
      },
    ]
};
const getters = {};
const mutations = {};
const actions = {};
export default {
  state,
  getters,
  mutations,
  actions
};